import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import TitleComponent from "./title-component";

export default function Indicator({
    downTime,
    duration,
    date,
    selectedDays,
  }: {
    downTime: boolean | undefined;
    duration: string;
    date: string;
    selectedDays: number;
  }) {
    const width = `${100 / selectedDays}%`;
    return (
      <>
        <Tooltip
          title={
            <TitleComponent downTime={downTime} duration={duration} date={date} />
          }
          placement="bottom"
        >
          <Grid
            item
            display={"flex"}
            style={{
              height: "30px",
              width: width,
              backgroundColor:
                downTime === undefined
                  ? "#cacacc"
                  : downTime
                  ? "#b91c1c"
                  : "#059669",
              borderRadius: "5px",
            }}
          ></Grid>
        </Tooltip>
      </>
    );
  }
  